import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import Button from 'components/Button'

import style from './ListingInfoBlock.style'

const ListingInfoBlockStyled = styled.div(props => ({ ...style(props) }))

const ListingInfoBlock = ({
    image,
    title,
    subtitle,
    swapTitles,
    buttonLink,
    buttonText,
    imageVerticalPosition,
    isNewsBlock,
    dealer
}) => {
    return (
        <ListingInfoBlockStyled
            image={image}
            swapTitles={swapTitles}
            imageVerticalPosition={imageVerticalPosition}
            isNewsBlock={isNewsBlock}
            dealer={dealer}>
            {image && <div className="Image" />}

            <div className={`Content ${dealer ? 'dealer' : ''}`}>
                {swapTitles && subtitle && !dealer && <p>{subtitle}</p>}
                <h2 className={dealer ? 'dealer' : ''}>{title}</h2>
                {!swapTitles && subtitle && !dealer && <p>{subtitle}</p>}

                {dealer && (
                    <>
                        <ul className="dealerLogos">
                            
                            {/* <li className="solaris">
                                <img
                                    src="https://res.cloudinary.com/merkandmerk/image/upload/v1603798095/Static/Logos/solaris_sb4s3z.svg"
                                    alt="Solaris Yachts"
                                />
                            </li> */}
                           <li className="princess">
                                <img
                                    src="https://res.cloudinary.com/merkandmerk/image/upload/v1606145064/Static/Logos/princess-new-logo_n0hgac.svg"
                                    alt="Princess Yachts"
                                />
                            </li>
                            
                            <li className="cranchi">
                                <img
                                    src="https://res.cloudinary.com/merkandmerk/image/upload/v1638537472/Static/Logos/cranchi_mah7n1.svg"
                                    alt="Cranchi"
                                />
                            </li>
                            
                            <li className="solaris-power">
                                <img
                                    src="https://res.cloudinary.com/merkandmerk/image/upload/v1603798149/Static/Logos/solaris-power_dfd7ay.svg"
                                    alt="Solaris Power"
                                />
                            </li>
                        </ul>
                        <p className="dealer">{subtitle}</p>
                    </>
                )}

                {buttonLink && (
                    <Button
                        link={buttonLink}
                        variation="secondary rounded"
                        white
                        small
                        dataAttrs={{
                            'gtm-event': 'link',
                            'gtm-label': title,
                            'gtm-action': buttonText,
                            'gtm-category': 'ListingInfoBlock'
                        }}>
                        {buttonText}
                    </Button>
                )}
            </div>
        </ListingInfoBlockStyled>
    )
}

ListingInfoBlock.propTypes = {
    image: PropTypes.string,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    swapTitles: PropTypes.bool,
    buttonLink: PropTypes.string,
    buttonText: PropTypes.string,
    imageVerticalPosition: PropTypes.string,
    isNewsBlock: PropTypes.bool,
    dealer: PropTypes.bool
}

ListingInfoBlock.defaultProps = {
    image: null,
    subtitle: null,
    swapTitles: false,
    buttonLink: null,
    buttonText: null,
    imageVerticalPosition: 'center',
    isNewsBlock: false,
    dealer: false
}

export default withTheme(ListingInfoBlock)
